// src/components/admin/design/WeeklyBannerPreview.tsx
"use client";

import React from "react";
import { WEEKLY_BANNER_VARIANTS } from "@/components/store/sections/weekly-banner";
import { resolveCurrentSubdomain } from "@/components/store/sections/navbar/brandingConfig";
import { useDetectedAdminTheme } from "./UniversalProductCardPreview";

export interface WeeklyBannerPreviewProps {
  variantId: string;
  primaryColor?: string;
  theme?: "dark" | "light";
  subdomain?: string;
}

export default function WeeklyBannerPreview({
  variantId = "classic_dark",
  theme: propTheme,
  subdomain: propSubdomain,
}: WeeklyBannerPreviewProps) {
  const [activeTheme] = useDetectedAdminTheme(propTheme);
  const isLight = activeTheme === "light";
  const resolvedSubdomain = resolveCurrentSubdomain(propSubdomain || "nextlook");

  const cleanKey = String(variantId || "classic_dark")
    .trim()
    .toLowerCase()
    .replace(/-/g, "_");
  const Comp =
    WEEKLY_BANNER_VARIANTS[cleanKey] || WEEKLY_BANNER_VARIANTS["classic_dark"];

  return (
    <div
      data-xylo-preview-theme={activeTheme}
      className={`w-full overflow-hidden rounded-2xl p-2 transition-colors ${
        isLight ? "text-slate-900" : "text-slate-100 dark"
      }`}
    >
      <Comp
        subdomain={resolvedSubdomain}
        banner={{
          id: 1,
          badge_title: "WEEKLY MEGA DEAL",
          title: "Flat 40% Off Curated Bestsellers",
          subtitle:
            "Grab our highest-rated products before the weekly countdown ends!",
          button_text: "Claim Weekly Deal",
          target_url: "/products",
          image:
            "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&auto=format&fit=crop&q=80",
        }}
      />
    </div>
  );
}